import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import StarRating from './StarRating/StarRating'
import QuotationMarks from './QuotationMarks'

const Review = ({ rating = 5, text, dark = false, big = false, reviewer }) => {
  if (!text) return null
  return (
    <div
      className={cn(
        'c-review flex flex-col justify-center items-center mb-24',
        {
          'c-review--dark': dark,
        }
      )}
    >
      <div className={cn(big ? 'pb-16' : 'pb-8')}>
        <StarRating rating={rating} big={big} />
      </div>
      <blockquote
        className={cn(
          'ml-0 pl-0 leading-body',
          big ? 'type-default' : 'type-17'
        )}
      >
        <p>
          <QuotationMarks>{text}</QuotationMarks>
        </p>
        {reviewer && (
          <footer className="mt-8">
            <cite className="type-small">— {reviewer}</cite>
          </footer>
        )}
      </blockquote>
    </div>
  )
}

Review.propTypes = {
  rating: PropTypes.number,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  dark: PropTypes.bool,
  big: PropTypes.bool,
  reviewer: PropTypes.string,
}

export default Review
